import React, { useState } from "react"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import "./style.scss"
import HybridLink from "../utils/HybridLink"

function Header() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  return (
    <div className="header position-fixed w-100 top-0">
      <div className="container">
        <div className="row">
          {/* logo */}
          <div className="col-11 col-md-12 col-lg-5 d-flex justify-content-start justify-content-md-evenly justify-content-lg-start align-items-center">
            <AniLink
              paintDrip
              hex="#551864"
              to="/"
              className="d-flex justify-content-start align-items-center headerLogo py-2"
            >
              <img
                loading="lazy"
                src="/images/logo.webp"
                className="img-fluid"
                alt=""
                width="40px"
              />
              <div className="d-none d-md-flex flex-column">
                <span className="text-uppercase fs-3 ps-2">codefumes</span>
                <small className="text-uppercase tagline ps-2">
                  Innovate, Experiment, Deploy
                </small>
              </div>
            </AniLink>
          </div>
          {/* big screen navbar */}
          <div className="col-md-12 col-lg-7 d-md-flex d-none justify-content-md-evenly pt-3  justify-content-lg-end align-items-center">
            <AniLink
              paintDrip
              hex="#551864"
              to="/services"
              className="navBtn mx-3"
            >
              Services
            </AniLink>
            <span className="navBtn mx-3">
              <HybridLink
                linkName="Portfolio"
                linkPath="/#portfolio"
                requiredPathname="/"
              />
            </span>
            {/* <AniLink paintDrip hex="#551864" to="/team" className="navBtn mx-3">
              Team
            </AniLink> */}
            <AniLink paintDrip hex="#551864" to="/lab" className="navBtn mx-3">
              Lab
            </AniLink>
            <AniLink paintDrip hex="#551864" to="/blog" className="navBtn mx-3">
              Blog
            </AniLink>
            <AniLink
              paintDrip
              hex="#551864"
              to="/getQuote"
              className="ms-3 getFreeQuoteBtn px-4 py-2 fw-bold"
              onMouseOver={() => {}}
            >
              GET QUOTE
            </AniLink>
            {/* <a
              href="https://www.upwork.com/agencies/~0188bb3e0025ec6c45"
              className="ms-3"
            >
              <img
                src="images/upwork_logo.webp"
                alt=""
                width="36px"
                className="rounded-circle"
              />
            </a> */}
          </div>
          {/* mobile menu button */}
          <div className="col-1 d-flex d-md-none justify-content-end pe-2 align-items-center fs-1 dotsMenuBtn">
            <button
              className="deadStyleBtn px-1"
              onClick={() => setMobileNavOpen(true)}
            >
              <i className="bi bi-list"></i>
            </button>
          </div>
          {/* mobile navpage */}
          {mobileNavOpen && (
            <div className="position-fixed h-100 w-100 mobileNavPage d-flex flex-column justify-content-start align-items-center pt-3">
              <div
                className="d-block w-100 d-flex justify-content-end align-items-start"
                style={{ maxWidth: "500px" }}
              >
                <button
                  className="deadStyleBtn"
                  onClick={() => setMobileNavOpen(false)}
                >
                  <i className="bi bi-x" style={{ fontSize: "2.3em" }}></i>
                </button>
              </div>
              <AniLink
                paintDrip
                hex="#551864"
                to="/getQoute"
                className="my-3 getFreeQuoteBtn px-4 py-2 fw-bold fs-3"
              >
                GET FREE QUOTE
              </AniLink>
              <AniLink
                paintDrip
                hex="#551864"
                to="/services"
                className="navBtn my-3 fs-3"
              >
                Services
              </AniLink>
              {/* <AniLink
                paintDrip
                hex="#551864"
                to="/team"
                className="navBtn my-3 fs-3"
              >
                Team
              </AniLink> */}
              <AniLink
                paintDrip
                hex="#551864"
                to="/lab"
                className="navBtn my-3 fs-3"
              >
                Lab
              </AniLink>
              <AniLink
                paintDrip
                hex="#551864"
                to="/blog"
                className="navBtn my-3 fs-3"
              >
                Blog
              </AniLink>
              <br />
              {/* <a
                href="https://www.upwork.com/agencies/~0188bb3e0025ec6c45"
                className="ms-3"
              >
                <img
                  src="images/upwork_logo.webp"
                  alt=""
                  width="42px"
                  className="rounded-circle"
                />
              </a> */}
              <img
                loading="lazy"
                src="/images/logo.webp"
                className="img-fluid mobileNavPageLogo"
                alt=""
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Header
